import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1319375c&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=1319375c&lang=scss&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1319375c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1319375c')) {
      api.createRecord('1319375c', component.options)
    } else {
      api.reload('1319375c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1319375c&scoped=true&", function () {
      api.rerender('1319375c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/customer/list.vue"
export default component.exports